export function getConfigurationFormFields(configuration) {
    return {
        ...configuration,
        validity: configuration?.validity || null,
        supportValidity: configuration?.supportValidity || null,
        runtimeFeatures: configuration?.runtimeFeatures || [],
    };
}
